import { Typography } from '@mui/material';

/**
 *
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 *
 * @Description Component CustomFullRowCard.
  * @param JSX.Element btnActions: JSX.Element for actions (required).
 * @param  JSX.Element children - Main content of the card body.
 * @param string actionLeft - Element displayed on the left side of the card header (e.g., a title or label).
 * @param JSX.Element actionRight - Element displayed on the right side of the card header (e.g., chips, tags, icons).
 * @returns {JSX.Element} Renders the customized row card with all provided information.
 */

const CustomFullRowCard = ({
    btnActions = 'details',
    children,
    actionLeft,
    actionRight,
    className,
}) => {

    return (
        <div className={`row-card-container ${className}`}>
            <div className='status-section border-bottom-shades-300'>
                <Typography className='ibl-font-w-600 ibl-ientry-p mb-3 '>{actionLeft}</Typography>
                <div className='right-items mb-3'>
                   {actionRight}
                </div>
            </div>
            <div className='card-body-row'>
               {children}
            </div>
            <div className="card-action">{btnActions}</div>
        </div>
    );
};

export default CustomFullRowCard;
